import { render, staticRenderFns } from "./noticePage2.vue?vue&type=template&id=27614812&scoped=true"
import script from "./noticePage2.vue?vue&type=script&lang=js"
export * from "./noticePage2.vue?vue&type=script&lang=js"
import style0 from "./noticePage2.vue?vue&type=style&index=0&id=27614812&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27614812",
  null
  
)

export default component.exports